import styles from "./Player.module.css"
import { Page } from "../../components/layout/Page"
import { Paper } from "../../components/content/Paper"
import { PlayerMainTitle } from "./player-main-title"
import { PlayerDetail } from "./player-detail"
import Navigation from "../navigation-footer/Navigation"
import { useEffect, useState } from "react"
import PlayLogs from "../playLogs/PlayLogs"
import { Spinner } from "flowbite-react"
import { usePlayer } from "./lib/player"
import { setPlayer } from "./store/actions"
import { useStoreShared } from "../../store"
import { useStorePlayer } from "./store"
import Programs from "../programs/Programs";

function Player() {
  const { statePlayer, dispatchPlayer } = useStorePlayer()
  const { stateShared } = useStoreShared()
  const [player, , ,] = usePlayer(stateShared.currentClient?.uuid)
  const [navigation, setNavigation] = useState("info")
  function getNavigation(value: string) {
    setNavigation(value)
  }
  useEffect(() => {
    window.scrollTo(0, 0)
    dispatchPlayer(setPlayer(player))
  }, [player])
  return (
    <div>
      {!statePlayer.player?.displayName && (
        <div className={styles.BlurScreen}>
          <div className={styles.centerScreen}>
            <Spinner size="xl"></Spinner>
          </div>
        </div>
      )}
      {statePlayer.player?.displayName && (
        <Page title={"Player info"}>
          <Paper className={styles.title_menu}>{statePlayer.player && <PlayerMainTitle player={statePlayer.player}></PlayerMainTitle>}</Paper>
          {navigation === "info" && (
            <Paper className={styles.title_menu}>{statePlayer.player && <PlayerDetail player={statePlayer.player}></PlayerDetail>}</Paper>
          )}
          {navigation === "logs" && (
            <Paper className={styles.title_menu}>
              {" "}
              <PlayLogs serviceName={statePlayer?.player?.serviceName}></PlayLogs>{" "}
            </Paper>
          )}
          {navigation === "programs" && (
            <Paper className={styles.title_menu}>
              {" "}
              <Programs></Programs>{" "}
            </Paper>
          )}

          <Navigation nav={getNavigation}></Navigation>
        </Page>
      )}
    </div>
  )
}

export default Player
